import { render, staticRenderFns } from "./GoldUpgrade.vue?vue&type=template&id=f7579c54&"
import script from "./GoldUpgrade.vue?vue&type=script&lang=js&"
export * from "./GoldUpgrade.vue?vue&type=script&lang=js&"
import style0 from "./GoldUpgrade.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports